// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__BAs0f","buttons":"RemoveExpirationActionButtons_buttons__3-gBa"};